import { useAppSelector } from '@common/hooks/store';
import { selectUserCountryCode } from '@features/auth/slice/authSlice';
import { useLazyGetMoneyGateBanksQuery } from '@features/deposit/screens/money-gate/api/moneyGateApi';
import DepositOnlineMoneyGateContainer
  from '@features/deposit/screens/money-gate/zone/tj/DepositOnlineMoneyGateContainer';
import { FC, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface IMoneyGateResultProps {
  orderId: string;
}

const DepositOnlineMoneyGateResult: FC<IMoneyGateResultProps> = ({ orderId }) => {
  const [ searchParams ] = useSearchParams();
  const countryCode = useAppSelector(selectUserCountryCode)?.toLowerCase();
  const [ activeStep, setActiveStep ] = useState<number>(0);

  const [ getMoneyGateBanks, {
    data,
  } ] = useLazyGetMoneyGateBanksQuery();

  useEffect(() => {
    if(countryCode !== 'ru') {
      getMoneyGateBanks({ orderId });
    }
  }, [countryCode, getMoneyGateBanks, orderId]);


  return (
    <DepositOnlineMoneyGateContainer
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      defaultBank={searchParams.get('bank')}
      defaultType={searchParams.get('type')}
      moneyGateBanks={data} orderId={orderId}/>
  );
};
export default DepositOnlineMoneyGateResult;